(function ($) {
  $(document).ready(function () {
    $('.jdgm-carousel .jdgm-carousel-item').each(function() {
      $(this).find(".jdgm-carousel-item__review-rating").insertAfter($(this).find(".jdgm-carousel-item__reviewer-name"));
    })    
    if ($('.the-details-master .box-container').length) {
      $('.the-details-master .box-container').owlCarousel({
        items:4,
        loop:false,
        dots: false,
        nav: false,
        margin:0,
        responsive:{
            0:{
              items:1,
              dots: true,
              loop:true,
            },
            768:{
                items:3,
                dots: true
            },
            1024:{
              items:4
          }
        }
      }); 
    }
    horizontalScrollHome();
    checkInstafeed(0);
    function checkInstafeed(c) {
      setTimeout(() => {
        if ($('#insta-feed > a').length && $('#insta-feed > a img').length) {         
          $('#insta-feed > a img').each(function() {
            var src = $(this).attr('data-src');
            var alt = $(this).attr('alt');
            var href = $(this).parents('a').attr('href');
            var image = "<div class='item'><img src='"+src+"' alt='"+alt+"' data-href='"+href+"' /></div>";
            $('.home-instagram .marquee-wrappers .items').append(image);
          });
          $('.home-instagram .marquee-wrappers .items img').click(function(){
            var win = window.open($(this).attr('data-href'), '_blank');
          });
          $('.home-instagram').show();
        } else if ($('#insta-feed .slide-page').length && $('#insta-feed .slide-page img').length) {         
          $('#insta-feed .slide-page').each(function() {
            var src = $(this).find('img').attr('data-src');
            var alt = $(this).find('img').attr('alt');
            var href = '';
            if($(this).find('a').length>0){
              href = $(this).find('a').attr('href');
            }
            var image = "<div class='item'><img src='"+src+"' alt='"+alt+"' data-href='"+href+"' /></div>";
            $('.home-instagram .marquee-wrappers .items').append(image);
          });
          $('.home-instagram .marquee-wrappers .items img').click(function(){
            var win = window.open($(this).attr('data-href'), '_blank');
          });
          $('.home-instagram').show();
        } else if ($('#insta-feed > .instafeed-container').length && $('#insta-feed > .instafeed-container img').length) {         
          $('#insta-feed > a img').each(function() {
            var src = $(this).attr('data-src');
            var alt = $(this).attr('alt');
            var image = "<div class='item'><img src='"+src+"' alt='"+alt+"' /></div>";
            $('.home-instagram .marquee-wrappers .items').append(image);
          });
          $('.home-instagram').show();
        } else { 
          checkInstafeed(c + 1)
        };
      }, 1000);
    }


  });
  $(window).resize(function() {
    horizontalScrollHome();
  });
  $(window).on("load",function(){
    horizontalScrollHome();    
  });
  function horizontalScrollHome() {
    if ($(window).width() < 768) {
      $('.template-index section[data-section-type=article-list] .ArticleList').mCustomScrollbar({
        axis:"x" // horizontal scrollbar
      });
    }
    if ($(window).width() < 1007) {
      $('.template-index section[data-section-type=featured-collections] .ProductList').mCustomScrollbar({
        axis:"x" // horizontal scrollbar
      });
    }
  }
})(jQuery);